import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { trackEvent } from 'dibs-tracking';

// components
import { FormattedMessage } from 'dibs-react-intl';
import { PdpSharedMakerHeadshotModule } from './PdpSharedMakerHeadshotModule/PdpSharedMakerHeadshotModule';
import { ExpandingAreaWithReadMore } from 'dibs-elements/exports/ExpandingArea';
import { PdpSharedStorytellingTrackingWrapper } from '../PdpSharedStorytellingComponents/PdpSharedStorytellingTracking';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

export const Title = () => (
    <PdpSharedStorytellingTrackingWrapper>
        <FormattedMessage
            id="PdpSharedDescriptionAboutMaker.aboutMakerHeader"
            defaultMessage="About The Maker"
        />
    </PdpSharedStorytellingTrackingWrapper>
);

export const Content = ({ contentClass, seller, liveStorefront }) => (
    <Fragment>
        <PdpSharedMakerHeadshotModule seller={seller} />
        <ExpandingAreaWithReadMore
            collapsedHeight={144}
            onReadMoreClick={({ type }) => {
                if (type === 'readMore') {
                    trackEvent({
                        category: 'promo interaction',
                        action: 'about the maker continue reading clicked',
                        label: 'pdp',
                    });
                }
            }}
        >
            <span className={classNames(styles.content, contentClass)}>
                {liveStorefront.aboutUs}
            </span>
        </ExpandingAreaWithReadMore>
    </Fragment>
);

Content.propTypes = {
    contentClass: PropTypes.string,
    seller: PropTypes.object,
    liveStorefront: PropTypes.object,
};

function PdpSharedDescriptionAboutMakerComponent(props) {
    const { headerClass, contentClass, item } = props;
    const liveStorefront = get(item, 'seller.liveStorefrontProfile') || {};

    if (!liveStorefront.aboutUs || !get(item, 'seller.isMakerOrManufacturer')) {
        return null;
    }

    return (
        <div data-tn="pdp-item-description-about-maker" className={styles.wrapper}>
            <h2 className={classNames(styles.header, headerClass)}>
                <Title />
            </h2>
            <Content
                contentClass={contentClass}
                seller={item.seller}
                liveStorefront={liveStorefront}
            />
        </div>
    );
}

PdpSharedDescriptionAboutMakerComponent.propTypes = {
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export const PdpSharedDescriptionAboutMaker = createFragmentContainer(
    PdpSharedDescriptionAboutMakerComponent,
    {
        item: graphql`
            fragment PdpSharedDescriptionAboutMaker_item on Item {
                seller {
                    isMakerOrManufacturer
                    sellerProfile {
                        company
                    }
                    sellerPreferences {
                        urlLabel
                    }
                    liveStorefrontProfile {
                        aboutUs
                        photos {
                            path
                            type {
                                name
                            }
                        }
                    }
                    ...PdpSharedMakerHeadshotModule_seller
                }
            }
        `,
    }
);
